// SEO content per trade — same template, different copy
export const TRADES = {
  reformas: {
    slug: "reformas",
    name: "Reformas",
    h1: "Presupuestos de reformas en 30 segundos con IA",
    title: "Presupuestos de reformas con IA · AutoPresupuestos Pro",
    meta: "Genera presupuestos profesionales para reformas integrales, baños, cocinas y obras menores. Plantillas listas, PDF con tu logo, envío directo al cliente.",
    intro: "Estás reformando un baño, una cocina o una vivienda completa. Cada cliente quiere un presupuesto detallado, claro y rápido. Con AutoPresupuestos Pro escribes el alcance del trabajo y la IA genera todas las partidas con precios reales del mercado español.",
    examples: ["Reforma integral piso 80 m²", "Renovación baño completo", "Reforma cocina con muebles", "Cambio de suelos y pintura"],
    benefits: [
      { t: "Partidas realistas", d: "Demolición, albañilería, instalaciones, acabados, gestión de residuos. Todo desglosado." },
      { t: "IVA o IGIC al instante", d: "Configura una vez tu gravamen y se aplica automático en todos los presupuestos." },
      { t: "Acepta y firma online", d: "El cliente recibe un enlace, lo revisa desde el móvil, lo acepta y lo firma." },
    ],
    faq: [
      { q: "¿Sirve para reformas grandes?", a: "Sí, edita cualquier partida tras la generación con IA. La IA te da el primer borrador, tú ajustas." },
      { q: "¿Puedo añadir mi logo y datos fiscales?", a: "Sí, en el onboarding configuras logo, color corporativo y datos. Aparecen en cada PDF." },
    ],
  },
  pintura: {
    slug: "pintura",
    name: "Pintura",
    h1: "Presupuestos de pintura sin esfuerzo",
    title: "Presupuestos de pintura · AutoPresupuestos Pro",
    meta: "Pintor autónomo: genera presupuestos de pintura interior y exterior en segundos. Cálculo por m², materiales y horas. Listo para enviar.",
    intro: "Ya no tendrás que sacar cuentas a mano. Indica metros cuadrados, número de manos y tipo de pintura — la IA calcula precio justo y partida de materiales si la incluyes.",
    examples: ["Piso 90 m² 2 manos color blanco", "Fachada 200 m²", "Habitación + techo", "Local comercial con esmalte"],
    benefits: [
      { t: "Precio por metro cuadrado", d: "Calcula automático según m² y tipo de superficie." },
      { t: "Con o sin materiales", d: "Tú decides si los aportas o los pone el cliente." },
      { t: "Recordatorios automáticos", d: "Si el cliente no responde en 3 días, le enviamos un email amable por ti." },
    ],
    faq: [
      { q: "¿Cómo calcula los precios?", a: "Usa precios de mercado español 2025 con factores por urgencia, dificultad y tipo de superficie." },
      { q: "¿Puedo guardar tarifas fijas?", a: "Tras la generación con IA, edita las partidas y los precios. La próxima vez puedes duplicar un presupuesto similar." },
    ],
  },
  electricidad: {
    slug: "electricidad",
    name: "Electricidad",
    h1: "Presupuestos para electricistas autónomos",
    title: "Presupuestos de electricidad con IA · AutoPresupuestos Pro",
    meta: "Genera presupuestos de instalaciones eléctricas, cuadros, puntos de luz, certificados. Profesional, rápido y con tu logo.",
    intro: "Instalaciones, ampliaciones, certificados, cuadros, domótica. Describe el trabajo y obtén un presupuesto con mano de obra, material aproximado y desplazamiento.",
    examples: ["Instalación cuadro general", "8 puntos de luz + interruptores", "Ampliación 3.000 W a 5.500 W", "Certificado de eficiencia energética"],
    benefits: [
      { t: "Mano de obra realista", d: "Tarifas €/h del mercado español por especialidad eléctrica." },
      { t: "Urgencias con recargo", d: "Recargos automáticos por trabajos urgentes (24-48h o fines de semana)." },
      { t: "Factura al aceptar", d: "Conecta tu cuenta de Holded o Quipu y emite factura con un clic." },
    ],
    faq: [
      { q: "¿Incluye boletines y certificados?", a: "Puedes añadir partidas específicas tras la generación con IA. Es totalmente editable." },
    ],
  },
  fontaneria: {
    slug: "fontaneria",
    name: "Fontanería",
    h1: "Presupuestos para fontaneros en 30 segundos",
    title: "Presupuestos de fontanería con IA · AutoPresupuestos Pro",
    meta: "Reparaciones, instalaciones, sustitución de calderas y termos. Genera presupuestos de fontanería al instante con tu logo.",
    intro: "Una fuga, una caldera nueva, un baño completo. Cada urgencia es diferente — y cada presupuesto también. Describe el problema y la IA estructura el trabajo en partidas claras.",
    examples: ["Sustituir caldera por bomba de calor", "Avería bajo fregadero", "Cambio termo eléctrico", "Instalación grifería completa"],
    benefits: [
      { t: "Partidas habituales", d: "Mano de obra, desplazamiento, material aproximado, urgencia." },
      { t: "Cliente firma online", d: "Sin papeleo. El cliente firma desde el móvil con el dedo." },
      { t: "Historial de clientes", d: "Cada cliente con sus presupuestos asociados, listo para repetir trabajos." },
    ],
    faq: [
      { q: "¿Calcula bien las urgencias?", a: "Sí. Marca 'Muy urgente' y aplica un recargo del 35% sobre la mano de obra." },
    ],
  },
  carpinteria: {
    slug: "carpinteria",
    name: "Carpintería",
    h1: "Presupuestos para carpinteros y ebanistas",
    title: "Presupuestos de carpintería con IA · AutoPresupuestos Pro",
    meta: "Muebles a medida, puertas, armarios, tarima. Crea presupuestos de carpintería profesionales en segundos.",
    intro: "Cuando trabajas a medida, cada cliente es único. Describe el mueble, la madera y los acabados — la IA monta el presupuesto con mano de obra y materiales coherentes.",
    examples: ["Armario empotrado lacado", "Puerta corredera de cristal", "Tarima flotante 60 m²", "Mesa comedor en roble"],
    benefits: [
      { t: "Maderas y acabados", d: "Indica el tipo de madera y la IA ajusta los precios de material." },
      { t: "PDF con tu marca", d: "Logo, color corporativo y datos del taller en cada presupuesto." },
      { t: "Duplicar trabajos similares", d: "Ahorra tiempo en clientes que repiten o trabajos parecidos." },
    ],
    faq: [
      { q: "¿Funciona para tarima/parquet por m²?", a: "Sí, indica metros cuadrados y la IA distribuye mano de obra + material por m²." },
    ],
  },
  limpieza: {
    slug: "limpieza",
    name: "Limpieza",
    h1: "Presupuestos para empresas y autónomos de limpieza",
    title: "Presupuestos de limpieza con IA · AutoPresupuestos Pro",
    meta: "Limpieza de fin de obra, comunidades, oficinas, cristales. Genera presupuestos profesionales en segundos.",
    intro: "Limpieza de fin de obra, cristales en altura, comunidades de vecinos. Cada servicio tiene su tarifa — describe el trabajo y la IA propone partidas y precios reales.",
    examples: ["Fin de obra 120 m²", "Cristales fachada local", "Limpieza profunda comunidad 4 plantas", "Oficina 200 m² mensual"],
    benefits: [
      { t: "Por horas o por m²", d: "La IA elige la unidad más coherente según el tipo de trabajo." },
      { t: "Productos opcionales", d: "Decide si los aportas tú o los pone el cliente." },
      { t: "Embudo de conversión", d: "Mira cuántos clientes ven, aceptan o rechazan tus presupuestos." },
    ],
    faq: [],
  },
  jardineria: {
    slug: "jardineria",
    name: "Jardinería",
    h1: "Presupuestos para jardineros profesionales",
    title: "Presupuestos de jardinería con IA · AutoPresupuestos Pro",
    meta: "Mantenimiento, diseño, podas, riego, césped. Genera presupuestos de jardinería profesionales con tu marca.",
    intro: "Mantenimiento mensual, diseño de jardín, podas, instalación de riego. Cada cliente quiere saber qué incluye y por cuánto tiempo — la IA estructura el contrato con claridad.",
    examples: ["Mantenimiento mensual jardín 200 m²", "Diseño + plantación", "Poda de árboles altos", "Riego automático"],
    benefits: [
      { t: "Periodicidad clara", d: "Diferencia entre trabajos puntuales y mantenimiento mensual." },
      { t: "Materiales vegetales", d: "Estima coste de plantas, sustrato y abonos." },
      { t: "Recordatorios automáticos", d: "El cliente recibe un email pasados 3 días si no ha contestado." },
    ],
    faq: [],
  },
  instalaciones: {
    slug: "instalaciones",
    name: "Instalaciones",
    h1: "Presupuestos para climatización y aerotermia",
    title: "Presupuestos de instalaciones con IA · AutoPresupuestos Pro",
    meta: "Aire acondicionado, calefacción, aerotermia, ventilación. Crea presupuestos profesionales en segundos.",
    intro: "Aire acondicionado split, multisplit, aerotermia, suelo radiante. Indica m² a climatizar y la IA propone equipo, instalación y mano de obra.",
    examples: ["Multisplit 1x4 vivienda 100 m²", "Bomba calor aerotermia", "Aire acondicionado oficina", "Suelo radiante 80 m²"],
    benefits: [
      { t: "Equipo + instalación", d: "Partidas separadas por equipo, mano de obra y desplazamiento." },
      { t: "IGIC para Canarias", d: "Configura una vez y se aplica auto en todos los presupuestos." },
      { t: "Convertir en factura", d: "Cuando el cliente acepta, conviértelo en factura en Holded/Quipu." },
    ],
    faq: [],
  },
};

export const TRADE_GENERIC = {
  slug: "general",
  name: "Todos los oficios",
  h1: "Presupuestos profesionales para autónomos, en 30 segundos",
  title: "Presupuestos para autónomos · AutoPresupuestos Pro",
  meta: "Pintura, albañilería, electricidad, fontanería, carpintería, limpieza, jardinería, instalaciones. Una sola herramienta para todos los oficios. PDF con tu logo, IA, envío al cliente y firma online.",
  intro: "Eres autónomo. Pintor, albañil, electricista, fontanero, carpintero, jardinero. Da igual el oficio — pasas más tiempo haciendo presupuestos en Word que el propio trabajo. AutoPresupuestos Pro lo cambia: describes el trabajo, la IA genera el presupuesto con tu logo y se lo mandas al cliente con firma online.",
  examples: ["Pintura piso 80 m²", "Reforma baño completo", "Instalación eléctrica vivienda", "Mantenimiento jardín mensual", "Reparación fontanería urgente", "Mueble a medida"],
  benefits: [
    { t: "Cualquier oficio", d: "8 plantillas de oficios + tipo de cliente (particular, empresa, comunidad)." },
    { t: "IA en español", d: "Entrenada con precios reales del mercado español 2025." },
    { t: "Tu marca, tu color", d: "PDF y página pública con tu logo y color corporativo." },
  ],
  faq: [
    { q: "¿Sirve para mi oficio si no está en la lista?", a: "Sí. Elige el más parecido y describe el trabajo en lenguaje natural — la IA se adapta." },
    { q: "¿Cuánto cuesta?", a: "14 días gratis sin tarjeta. Después Básico 29 €/mes (presupuestos IA, clientes, PDF, firma) o PRO 39 €/mes (todo + BC3, OCR, contabilidad, Verifactu). Sin permanencia." },
    { q: "¿Y si invito a un colega?", a: "Por cada autónomo que se registre con tu enlace y se suscriba, ambos recibís 1 mes gratis. A los 5 invitados convertidos, recibes la insignia Bronce + bonus extra." },
  ],
};
